import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import RegionLogo from '@/components/RegionLogo.vue';
import store from '~store';
import ImageRetina from '~widget/ImageRetina';


export default /*#__PURE__*/_defineComponent({
  __name: 'RedeemTeaser',
  setup(__props) {

const { getters } = store;
const brand = computed(() => getters?.getBrand);
const numberOfShops = computed(() => getters.getNumberOfShops);
const image = computed(() => getters.getKeyVisualImage);
const showKeyVisualText = computed(() => getters.getShowKeyVisualText);

return { __sfc: true,getters, brand, numberOfShops, image, showKeyVisualText, RegionLogo, ImageRetina }
}

})